// extracted by mini-css-extract-plugin
export default {"root":"LegalLayout_root__+Zw9e","main":"LegalLayout_main__-mzqH","inner":"LegalLayout_inner__9dTAO","sidebar":"LegalLayout_sidebar__bHwBZ","content":"LegalLayout_content__LYBQ2"};